/** Serialize every availability RPC, including focus/interval refreshes and tabs. */
let pending: Promise<unknown> = Promise.resolve();

export async function scheduleEventAvailability<T>(
  request: () => PromiseLike<T>,
  signal?: AbortSignal,
): Promise<T> {
  const run = async (): Promise<T> => {
    signal?.throwIfAborted();
    // Keep the slot until the HTTP response settles. Aborting a fetch does not
    // prove Postgres stopped executing; releasing early could overlap queries.
    return await request();
  };
  if (typeof navigator !== 'undefined' && navigator.locks) {
    return await navigator.locks.request('portal:event-availability:v1', { signal }, run);
  }
  // Non-Web-Locks environments retain per-tab serialization. Rejection must not
  // poison later reads; cancellation is checked before a queued request starts.
  const result = pending.then(run);
  pending = result.catch(() => undefined);
  return result;
}
